import Matter from 'matter-js';

import { Dim, Entity } from '../../models';
import Note from '../renderers/Note';
import { posOf, getNoteDims } from '../../helpers';
import { NOTE_KEYS } from '../../constants/layout';

export default (
  windowDims: Dim,
  xOff: number,
  y: number,
  prompt: string,
  answer: string,
  timing: number,
  theme = NOTE_KEYS.center,
  attemptable = true,
  state?: string
): Entity => {
  const dims = getNoteDims(windowDims);
  const body = Matter.Bodies.rectangle(
    windowDims.w / 2 + xOff,
    y,
    dims.w,
    dims.h,
    { type: 'note' }
  );

  return {
    dims,
    getPos: () => posOf(body),
    timing,
    body,
    prompt,
    answer,
    garbageTime: -1,
    xOffIdx: Math.sign(xOff) + 1,
    windowDims,
    theme,
    state,
    attemptable,
    renderer: Note,
  };
};
